import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'react-bootstrap';
import { Outlet, useLocation } from 'react-router-dom';

/* global gtag */

import Header from './components/Header';
import Footer from './components/Footer';
import CountdownBanner from './components/CountdownBanner';
import { logout } from './slices/authSlice';
import ScrollToTop from './components/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGetDiscountQuery } from './slices/discountApiSlice';

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { data: discount } = useGetDiscountQuery();
  const bannerActive = discount?.isActive && discount?.endTime && new Date() <= new Date(discount.endTime);

  useEffect(() => {
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  useEffect(() => {
    const expirationTime = localStorage.getItem('expirationTime');
    if (expirationTime) {
      const currentTime = new Date().getTime();

      if (currentTime > expirationTime) {
        dispatch(logout());
      }
    }
  }, [dispatch]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}  // Enable RTL for all toasts
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{
          direction: 'rtl',
          textAlign: 'right',
          fontFamily: 'inherit'
        }}
      />
      <ScrollToTop />
      <CountdownBanner />
      <Header />
      <main className='py-3' style={{ marginTop: bannerActive ? '8rem' : '5rem' }}>
        <Container>
          <Outlet />
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default App;